import { ProductManagementModel } from './product-management.model';

export class ProductManagementLicenseModel {
    licenseMap: Map<string, Map<string, Array<ProductManagementModel>>>;

    constructor() {
        this.licenseMap = undefined;
    }
}
